<template>
	<v-contextual-content align="right" class="account">
		<template v-slot:trigger>
			<button>Account</button>
		</template>
		<div class="account__dropdown">
			<div class="account__dropdown__auth-summary flex gap-2">
				<dl>
					<dt class="sr-only">User</dt>
					<dd class="beta heavy">
						<nobr v-html="$present('fullName', $authed())"/>
					</dd>
					<dd class="text--light" v-html="$authed().email"/>
				</dl>
				<figure>
					<figcaption v-html="$present('initials', $authed())"/>
				</figure>
			</div>
			<ul class="account__dropdown__options">
				<li>
					<button
						class="account__dropdown__options__sign-out"
						@click.prevent="logout()">Sign out
					</button>
				</li>
			</ul>
		</div>
	</v-contextual-content>
</template>
<script>
import {mapActions} from "vuex";

export default {
	methods: {
		...mapActions("authStore", [
			"logout",
		]),
	},
};
</script>
